/* eslint-disable import/no-named-as-default */

import React, { useState } from "react";

import styles from "./ForgotPassword.module.scss";
import logo from "assets/img/compliancy-group-logo.png";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux"
import Button from "components/Button/Button";
import { submitUserLoginFormAction, submitUserForgotPasswordAction } from "store/actions/Actions";

import ReCAPTCHA from "react-google-recaptcha";

import WelcomePanel from "../components/WelcomePanel/WelcomePanel";
import FormElement from "components/FormElement/FormElement";
import InputAdornment from "components/InputAdornment/InputAdornment";

const ForgotPassword = props => {

    const [stateErrors, setStateErrors] = useState({});
    const [validateCaptcha, setValidateCaptcha] = useState(false);

    const handleForgot = (e) => {
        const email = document.getElementById('user-login').value || "";
        if (email !== "" && validateCaptcha) {
            props.submitUserForgotPasswordAction({ email });
        } else {
            if (email === "") {
                setStateErrors((s) => ({ ...s, user: 'Email is required!' }));
            }
            if (!validateCaptcha) {
                setStateErrors((s) => ({ ...s, captcha: 'Captcha is required!' }));
            }
        }
    }

    return (
        <WelcomePanel type="forgot">
            <div className={styles["login-panel-heading"]}>
                <img className={styles.logo} src={logo} alt="" />
            </div>

            <div className={styles["login-panel-content"]}>

                <p className={styles.welcome}>Enter your e-mail address!</p>

                <FormElement
                    htmlFor="user"
                    errorMessage={stateErrors.user}
                >
                    <InputAdornment iconStart="fal fa-at">
                        <input
                            type="text"
                            placeholder="E-mail"
                            name="user"
                            id="user-login"
                            onChange={() => {
                                setStateErrors((s) => ({
                                    ...s,
                                    user: '',
                                }))
                            }}
                        />
                    </InputAdornment>
                </FormElement>

                <div className={styles.captcha}>
                    <FormElement
                        htmlFor="captcha"
                        errorMessage={stateErrors.captcha}
                    >
                    <ReCAPTCHA
                        sitekey="6Ld0WPIcAAAAAOz52paGQr347GoH4G3ildK_YUv3"
                        onChange={() => {
                            setValidateCaptcha(true);
                            setStateErrors((s) => ({ ...s, captcha: '' }));
                        }}
                        onExpired={() => setValidateCaptcha(false)}
                    />
                    </FormElement>
                </div>

            </div>

            <div className={styles["login-panel-footer"]}>
                <Button text={"SEND EMAIL"} onClick={handleForgot} />
            </div>
        </WelcomePanel>
    );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {
    submitUserLoginFormAction,
    submitUserForgotPasswordAction,
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgotPassword));
